import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { SharedModule } from 'app/shared/shared.module';

import { HttpClientService, applicationHttpClientCreator } from './services/http-client.service';

import { TokenInterceptor } from './services/token.interceptor';
import { ErrorInterceptor } from './services/error.interceptor';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    { provide: HttpClientService, useFactory: applicationHttpClientCreator, deps: [HttpClient] },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ]
})
export class CoreModule { }
